import './App.css'
import { Route, Routes } from 'react-router-dom'
import { Layout } from './layouts/Layout.tsx'
import AboutPage from './pages/AboutPage/AboutPage.tsx'
import ContactPage from './pages/ContactPage/ContactPage.tsx'
import ErrorPage from './pages/ErrorPage/ErrorPage.tsx'
import LandingPage from './pages/LandingPage.tsx'
import ProjectsPage from './pages/ProjectsPage/ProjectsPage.tsx'

function App() {
	return (
		<Routes>
			<Route element={<Layout />}>
				<Route index element={<LandingPage />} />
				<Route path="/" element={<LandingPage />} />
				<Route path="/about" element={<AboutPage />} />
				<Route path="/projects" element={<ProjectsPage />} />
				<Route path="/contact" element={<ContactPage />} />
				<Route path="*" element={<ErrorPage />} />
			</Route>
		</Routes>
	)
}

export default App
